import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/styles';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import RTL from '../../../../components/RTL';
import mockData from './data';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Pagination from '@material-ui/lab/Pagination';
import {useDispatch, useSelector} from 'react-redux';
import {Loading} from 'redux/Action';
import {axios} from './../../../../axios';
import {SearchInput} from 'components';

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: 'auto',
    position: 'relative',
    overflow: 'unset',
  },
  ellipsis: {
    maxWidth: 100, // percentage also works
    whiteSpace: 'nowrap',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  searchInput: {
    padding: theme.spacing(2),
  },
  imageButton: {
    position: 'absolute',
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
  },
  imageInput: {
    display: 'none',
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
}));
let filter_txt = '';

const CompanyList = (props) => {
  const classes = useStyles();
  const {
    onDelete,
    onInfo,
    ChangeId,
    showEdit,
    reload,
    selData,
    del,
    edit,
    info,
  } = props;
  let Pr_inventory = useSelector((state) => state.permission);
  const current_role = useSelector((state) => state.role);
  const token = useSelector((state) => state.token);
  const [data, setData] = React.useState([]);
  const [LastPage, setLastPage] = React.useState(1);
  const [Page, setPage] = React.useState(1);
  const [filter, setFilter] = React.useState('');
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const GetData = async () => {
    try {
      const res = await axios.get(`companies?q=${filter_txt}&page=${Page}`, {
        headers: headers,
      });
      setLastPage(res.data.companies.last_page);
      if (LastPage == 1) {
        setPage(1);
      }
      setData(res.data.companies.data);
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }

    //alert(res)
  };

  useEffect(() => {
    dispatch(Loading());
    GetData();
  }, [Page, reload]);

  const handleKeyDown = (event) => {
    setPage(1);
    if (event.key === 'Enter') {
      filter_txt = event.target.value;
      setData([]);
      GetData();
      dispatch(Loading());
    }
  };

  return (
    <RTL>
      <>
        <div className={classes.searchInput}>
          <SearchInput
            onKeyDown={handleKeyDown}
            placeholder="نام شغل مورد نظر را جستجو کنید"
          />
        </div>
        {!isLoading ? (
          <>
            {data ? (
              data.length > 0 ? (
                <TableContainer className={classes.tableContainer}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">نام شغل</TableCell>
                        <TableCell align="center"> شماره تماس </TableCell>
                        <TableCell align="center" sortDirection="desc">
                          عملیات
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.tableBody}>
                      {data.map((data_company) => (
                        <TableRow hover key={data_company.id}>
                          <TableCell
                            className={classes.ellipsis}
                            align="center"
                          >
                            {data_company.name}
                          </TableCell>
                          <TableCell align="center">
                            {data_company.tell}
                          </TableCell>

                          <TableCell
                            align="center"
                            style={{display: 'flex', justifyContent: 'center'}}
                          >
                            <IconButton
                              disabled={edit || del || info}
                              style={
                                edit || del || info
                                  ? {color: '#7f8c8d'}
                                  : {color: '#a29bfe'}
                              }
                              onClick={() => {
                                onInfo();
                                ChangeId(data_company.id);
                                selData(
                                  data
                                    .filter((dt) => dt.id == data_company.id)
                                    .map((filterData) => filterData)
                                );
                              }}
                              color="error"
                              aria-label="upload picture"
                              component="span"
                            >
                              <VisibilityIcon />
                            </IconButton>
                            {current_role == 'Super-Admin' ||
                              Pr_inventory.indexOf('company.edit') !=
                                -1  ? (
                            <IconButton
                              disabled={edit || del || info}
                              style={
                                edit || del || info
                                  ? {color: '#7f8c8d'}
                                  : {color: '#6c5ce7'}
                              }
                              onClick={() => {
                                showEdit();
                                ChangeId(data_company.id);
                                selData(
                                  data
                                    .filter((dt) => dt.id == data_company.id)
                                    .map((filterData) => filterData)
                                );
                              }}
                              color="error"
                              aria-label="upload picture"
                              component="span"
                            >
                              <EditIcon />
                            </IconButton>
                               ) : (
                                ''
                              )} 
                               {current_role == 'Super-Admin' ||
                              Pr_inventory.indexOf('company.remove') !=
                                -1  ? (
                            <IconButton
                              disabled={edit || del || info}
                              style={
                                edit || del || info
                                  ? {color: '#7f8c8d'}
                                  : {color: '#E65D62'}
                              }
                              onClick={() => {
                                onDelete();
                                ChangeId(data_company.id);
                                selData(
                                  data
                                    .filter((dt) => dt.id == data_company.id)
                                    .map((filterData) => filterData)
                                );
                              }}
                              color="error"
                              aria-label="upload picture"
                              component="span"
                            >
                              <DeleteIcon />
                            </IconButton>
                              ) : (
                                ''
                              )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {LastPage > 1 ? (
                    <Pagination
                      style={{margin: 10}}
                      variant="outlined"
                      onChange={handleChangePage}
                      page={Page}
                      count={LastPage}
                      color="primary"
                    />
                  ) : (
                    ''
                  )}
                </TableContainer>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flex: 1,
                    alignItems: 'center',
                    padding: 50,

                    height: '100%',
                    justifyContent: 'center',
                  }}
                >
                  <Typography>متاسفانه هیچ رکوردی یافت نشد</Typography>
                </div>
              )
            ) : (
              ''
            )}
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              height: '100%',
              justifyContent: 'center',
            }}
          >
            <CircularProgress size={24} />
          </div>
        )}
      </>
    </RTL>
  );
};

export default CompanyList;
